export function Logo({ className = "h-9" }) {
  return (
    <img
      src="/3b-logo.webp"
      alt="3B LDN — Bonded by Bullion"
      className={`${className} w-auto object-contain select-none`}
      draggable={false}
    />
  );
}
